export const ROUTES = [
  { id: 'home' },
  { id: 'work' },
  { id: 'about' },
  { id: 'skills' },
  { id: 'journey' },
  { id: 'blog' },
  { id: 'contact' }
] as const;

export const HOME_ID = ROUTES[0].id;
export const NAV_ITEMS = ROUTES.slice(1);

export type SectionId = (typeof ROUTES)[number]['id'];

// Optional video backgrounds per section. Scroll-driven CSS animations control
// playback feel — add a video URL here to enable the background for that section.
export const SECTION_VIDEOS: Partial<Record<SectionId, string>> = {
  home: import.meta.env.VITE_HOME_PAGE_VIDEO_URL
};

export const navigate = (to: string) => {
  window.history.pushState(null, '', to);
  window.dispatchEvent(new Event('pushstate'));
};
